import React, { useContext } from 'react';
import { PageContext } from '../context';
import PageLayout from '../../shared/PageLayout';
import UserInfoHeader from '../../shared/UserInfoHeader';
import ProductPageBody from './ProductPageBody';

const ProductLandingPageContent = () => {
  const {
    contextData: {
      productData: {
        firstName, lastName, profession, avatarUrl, product,
      },
    },
  } = useContext(PageContext);
  console.log(product);
  return (
    <PageLayout isDark={false}>
      <UserInfoHeader
        firstName={firstName}
        lastName={lastName}
        description={profession}
        avatarImg={avatarUrl}
      />
      <ProductPageBody product={product} />
    </PageLayout>
  );
};

export default ProductLandingPageContent;
